<script setup lang="ts">
import { OpenAPI } from "./api.generated/scion";

OpenAPI.BASE = (import.meta.env.VITE_SCION_BASE_URL as string).split(",")[0];
</script>

<template>
  <div class="flex p-4 max-w-3xl min-h-full m-auto print:max-w-full">
    <router-view :token="$route.params.token" />
  </div>
</template>

<style scoped></style>
